<div class="container mt-5 mb-3 px-4">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="page-header mb-4">
        <button [routerLink]="'/templates'" style="background: #386AF6;border: 1px solid #ECECEC;border-radius: 20px;color:#FFF;transform: matrix(0, 1, -1, 0, 0, 0);">
            <span class="glyphicon glyphicon-chevron-left" style="transform: rotate(-90deg);top: 2px;left: -1px;"></span>
        </button>
        <label>{{templateData.templatename}}</label>
    </div>
    <div class="row">
        <div class="col-md-7">
            <div class="card card-height p-3 mb-2">
                <div class="card-body">
                    <div class="row px-2 bd-highlight my-2">
                        <div class="col-4">
                            <label class="mat-input-edit-label"> Template Name </label>
                        </div>
                        <div class="col-6" style="font-size: 14px;letter-spacing: 0.2px;">{{templateData.templatename}}</div>
                        <div class="bottom-line"></div>
                    </div>
                    <div class="row px-2 py-2 bd-highlight">
                        <div class="col-4">
                            <label class="mat-input-edit-label"> Template type </label>
                        </div>
                        <div class="col-6" style="font-size: 14px;letter-spacing: 0.2px;">{{templateData.template.type}}</div>
                        <div class="bottom-line"></div>
                    </div>
                    <div class="row px-2 bd-highlight my-2">
                        <div class="col-4">
                            <label class="mat-input-edit-label"> Status </label>
                        </div>
                        <div class="col-6" style="font-size: 14px;letter-spacing: 0.2px;">
                            <span class="active-label" *ngIf="templateData.status === 'ACTIVE'">Approved &nbsp;
                                <img src="../../../assets/success-tick-icon.png" style="width: 5%;">
                            </span>
                            <span class="pending-label" *ngIf="templateData.status === 'PENDING_REVIEW'">Pending &nbsp;
                                <!-- <img src="../../../assets/error-cross-icon.png" style="width: 5%;"> -->
                            </span>
                            <span class="inactive-label" *ngIf="templateData.status === 'REJECTED'">Rejected &nbsp;
                                <img src="../../../assets/error-cross-icon.png" style="width: 5%;">
                            </span>
                            <!-- <span style="color: #999999;letter-spacing: 0.02em;font-size: 12px;">Approval on {{templateData.created_at | dateTransform: 'std' }}</span> -->
                        </div>
                    </div>
                    <div class="row px-2 py-2 bd-highlight" *ngIf="templateData.status == 'REJECTED'">
                        <div class="col-4">
                            <label class="mat-input-edit-label"> Reason </label>
                        </div>
                        <div class="col-6" style="font-size: 14px;letter-spacing: 0.2px;">{{templateData.status_reason}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card card-height p-3 mb-2">
                <div class="card-body">
                    <div class="message-layout" style="background-color: #F4F6FA;width: 270px;">
                        <div style="width: 250px;height: 177px;border-radius: 8px;" class="px-2 py-2" *ngIf="templateType != 'text' && (templateType != 'button' || type != 'text')">
                            <img *ngIf="templateType == 'image' || (templateType == 'button' && type === 'image')" src="../../../assets/preview-img.svg" style="width:250px ;max-height: 200px;border-radius: 8px;">
                            <img *ngIf="templateType == 'document'" src="../../../assets/preview-docu.svg" style="width:250px ;max-height: 200px;border-radius: 8px;">
                            <img *ngIf="templateType == 'video'" src="../../../assets/preview-video.svg" style="width:250px ;max-height: 200px;border-radius: 8px;">
                        </div>
                        <div class="px-3 py-2" style="font-size: 13px;line-height: 130%;letter-spacing: -0.2px;white-space: pre-line;">
                            <label class="mat-input-edit-label" [innerHTML]="bodytext"></label>
                        </div>
                        <div style="width: 250px;height: 177px;border-radius: 8px;" class="px-2 py-2" *ngIf="templateType == 'button' && buttons.length == 0">
                            <img src="../../../assets/preview-btn.svg" style="width:250px ;max-height: 200px;border-radius: 8px;">
                        </div>
                        <div *ngFor = "let button of buttons">
                            <button style="justify-content: center;align-items: center;background: #FFFFFF;border: none;margin: 2.5%;margin-left: 5%;width: 90%;font-size: 12px;padding: 3.5%;border-radius: 12px;color: #386AF6;font-weight: 500;">
                                <span *ngIf="button.icon && button.icon != ''">
                                    <img [src]="'assets/'+button.icon+'.svg'" style="width: 30px;">&nbsp;&nbsp;
                                </span>{{button.body}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>